export enum CounterPartyType {
    NATURAL_PERSON = 'NP',
    COMPANY = 'NNP',
}
